export enum ShowingStatus {
  PENDING = 'Pending',
  CONFIRMED = 'Confirmed',
  COMPLETED = 'Completed',
  CANCELED = 'Canceled',
  DECLINED = 'Declined',
  EXPIRED = 'Expired',
}
